// @ts-nocheck

/**
 * * `emerging` - Emerging
 * `developing` - Developing
 * `established` - Established
 */
export type ReaderProfilePrintAwarenessEnum =
  typeof ReaderProfilePrintAwarenessEnum[keyof typeof ReaderProfilePrintAwarenessEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReaderProfilePrintAwarenessEnum = {
  emerging: "emerging",
  developing: "developing",
  established: "established",
} as const;
